import axios from "axios";
import { getCookie } from "../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

const getHeader = () => ({
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  Authorization: getCookie("mawalog"),
});

export const getOrgLogoApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `get_org_image`, {
      headers: getHeader(),
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching organization logo:", err);
  }
};

export const getProfileDetailsApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `basicprofile`, {
      headers: getHeader(),
    });
    return response;
  } catch (err) {
    console.error("Error fetching options:", err);
    return err.response || null;
  }
};

export const updateProfileImageApi = async (data) => {
  try {
    const response = await axios.post(adminApiUrl + `user/image_update`, data, {
      headers: getHeader(),
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const reportAnIssueApi = async (data) => {
  try {
    const response = await axios.post(adminApiUrl + `report_issue`, data, {
      headers: getHeader(),
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getReportIssueTypeApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `get_issue_type`, {
      headers: getHeader(),
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getFAQListApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `help?application=Asset`, {
      headers: getHeader(),
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getOrgListApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `get_enrolled_orgs`, {
      headers: getHeader(),
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getSwitchAccountApi = async (id) => {
  try {
    const response = await axios.get(adminApiUrl + `switch_org/${id}`, {
      headers: getHeader(),
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getRolePermissionApi = async (id) => {
  try {
    const response = await axios.get(adminApiUrl + "get_role_permission/" + id, {
      headers: getHeader(),
    });
    return response;
  } catch (err) {
    console.error("Error fetching role permissions:", err);
  }
};

export const getRoleTypeApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + "get_role_type", {
      headers: getHeader(),
    });
    return response;
  } catch (err) {
    console.error("Error fetching role type:", err);
  }
};
